import { Badge } from '@repo/shadcn';

export const PaymentStatusBadge = ({ status }: { status?: string }) => {
    if (status === 'due') {
        return (
            <Badge
                className="bg-orange-500 text-xs uppercase text-white hover:bg-orange-600"
                variant={'secondary'}
            >
                {status}
            </Badge>
        );
    }

    if (status === 'paid') {
        return (
            <Badge
                className="bg-green-600 uppercase text-white hover:bg-green-700"
                variant={'secondary'}
            >
                {status}
            </Badge>
        );
    }

    return (
        <Badge
            className="bg-gray-500 uppercase text-white hover:bg-gray-600"
            variant={'secondary'}
        >
            {status}
        </Badge>
    );
};

PaymentStatusBadge.displayName = 'PaymentStatusBadge';
